<template>
  <div>
    <h5>{{model.year}} {{model.makeDescription}} {{model.modelDescription}}</h5>
    <h6 v-for="(attr, key) in attributes" :key="key"><span>{{key}}</span> {{attr}}</h6>
    <p class="warranty-warning">Please note: This is a custom product, made to order for your vehicle. Seat covers in most fabric and color combinations for most vehicles are non-returnable, except as covered by our <a href="https://www.rufftuff.com/warranty-and-returns" target="_blank">Warranty</a>. Fabric samples are available upon request.</p>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState([
        'model',
        'attributes'
        ])
    }
  }
</script>

<style lang="scss">
h5 {
  font-family: $body-font-family !important;
  font-size: 22px;
  font-weight: 700;
  line-height: 22px;
  margin: 15px 0 0;

  @media screen and (min-width: 600px) {
    font-size: 32px;
    font-weight: 700;
    line-height: 32px;
    margin: 30px 0 0;  
  }
}
h6 {
  font-family: $body-font-family !important;
  font-size: 16px;
  font-weight: 300;

  @media screen and (min-width: 600px) {
    font-size: 20px;
  }

  &:first-of-type {
    padding-top: 10px;
  }

  &:last-of-type {
    margin-bottom: 20px;

    @media screen and (min-width: 600px) {
      margin-bottom: 40px;
    }
  }

  span {
    font-weight: 700;
    text-transform: capitalize;
  }
}

.warranty-warning {
  color: #666;
  margin: 1rem 0;
  max-width: 500px;
  font-size: 14px;
}
</style>
